import React from 'react'

import { usePlaceTypes } from '../../../utils/helpers/placeTypes'
import MinicrudsFilterV2 from '../../minicruds/filters/MinicrudsFilterV2'
import PlacesFilterV2 from '../../places/filters/PlacesFilterV2'
import ActivatedFilter from '../../../components/filter/ActivatedFilter'

const AssetFiltersList = () => {
  const [types] = usePlaceTypes()

  return (
    <>
      {types.map(type => (
        <PlacesFilterV2 key={type.id} label={type.name} filter={{ types: type.key }} icon={type.icon} />
      ))}
      <MinicrudsFilterV2 filter={{ entities: 'assetType' }} />
      <ActivatedFilter />
    </>
  )
}

export default AssetFiltersList
